import React, {useCallback} from 'react';
import DeleteIcon from '@material-ui/icons/Delete';
import AddLocationIcon from '@material-ui/icons/AddLocation';
import IconButton from '@material-ui/core/IconButton';
import {TrackDispatcher} from '../../../hooks/useTracks';
import theme from '../../../theme';
import PopupCloseButton from './PopupCloseButton';

interface TrackPointPopupProps {
    trackDispatcher: TrackDispatcher;
    point: TrackPoint;
    onPopupChange: (popup: MapPopup) => void;
    onOverlaysChange: SetState<MapOverlays>;
    overlays: MapOverlays;
}

export default function TrackPointPopup({
    trackDispatcher,
    point,
    onPopupChange,
    onOverlaysChange,
    overlays,
}: TrackPointPopupProps) {
    const {pointLocalId, trackLocalId} = point.properties;

    return <>
        <PopupCloseButton onClick={useCallback(() => onPopupChange(undefined), [onPopupChange])} />
        <IconButton
            onClick={() => trackDispatcher({type: 'removePoint', pointLocalId, trackLocalId})}
            color="secondary"
            style={{margin: theme.spacing(-1)}}
        >
            <DeleteIcon style={{height: 24, width: 24}} />
        </IconButton>
        <IconButton
            onClick={() => {
                onOverlaysChange({...overlays, showWaypoints: true});
                trackDispatcher({
                    type: 'updatePoint',
                    point: {
                        ...point,
                        properties: {
                            ...point.properties,
                            attr: null,
                        }
                    }
                });
            }}
            color="primary"
            style={{margin: theme.spacing(-1)}}
        >
            <AddLocationIcon style={{height: 24, width: 24}} />
        </IconButton>
    </>;
}
